
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon-arpeggio",classNames,staticClass],
              style: [{"isolation":"isolate"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","style":"isolation:isolate","viewBox":"0 0 24 24","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"secondary",attrs:{"d":"M18.949 16.377a1 1 0 11-1.994-.015l.42-13.962c.632.001.991.727 1.669.6l-.095 13.377z"}}),_c('path',{staticClass:"primary",attrs:{"d":"M2.149 21.316c-.283-1.2 1.233-2.585 3.382-3.09 2.149-.506 4.123.058 4.405 1.258.282 1.2-1.233 2.584-3.382 3.09-2.149.505-4.123-.058-4.405-1.258z"}}),_c('path',{staticClass:"secondary",attrs:{"d":"M11.128 18.212c-.283-1.2 1.233-2.585 3.382-3.091 2.149-.505 4.123.059 4.405 1.258.282 1.2-1.233 2.585-3.382 3.091-2.149.505-4.123-.059-4.405-1.258z"}}),_c('path',{staticClass:"primary",attrs:{"d":"M9.975 6.178L9.97 19.481a1 1 0 11-1.994-.014L8.271 5.06q.39-.391 10.713-3.552c.082.69.132 1.147.061 1.733q-.39.391-9.07 2.937z"}})])
          )
        }
      }
    